export class HistoricalBar {
  color: string;

  constructor(init: Readonly<HistoricalBar>) {
    Object.assign(this, init);
  }
}
